import { Promotions } from "src/screens/Public/Promotions";
import { MenuItem } from "../../../../commons/ui/menu";

export const routes: MenuItem[] = [
  {
    key: "privatePromotionsMain",
    basePath: "/",
    target: {
      component: Promotions,
      path: "/",
    },
    enabled: true,
    icon: "List",
    text: "Promotions",
    children: [],
    default: true,
  },
];
